export class User {
  pagare: any;
  fechaAct: any;
  constructor(
    public id: number,
    public usuario: string,
    public role: string,
    public password: string,
    public created_at: string,
    public updated_at: string,
    public remember_token: string,
    public aporte: number,
    public ahorro: number,
  ) {}
}
